import { withWriterSection } from './withWriterSection'
import { WriterSection } from './WriterSection'

const ConnectedWriterSection = withWriterSection(WriterSection)

export { ConnectedWriterSection as WriterSection }
